import type { LoadState } from "@redotech/react-util/load";
import type { ReturnsOnboardingResumeState } from "./returns-onboarding-resume-state";

export function visibleReturnsOnboardingResumeState({
  onboardingProductsEnabled,
  returnsEnabled,
  state,
}: {
  onboardingProductsEnabled: boolean;
  returnsEnabled: boolean;
  state: LoadState<ReturnsOnboardingResumeState>;
}): NonNullable<ReturnsOnboardingResumeState> | undefined {
  if (
    !onboardingProductsEnabled ||
    returnsEnabled ||
    state.pending ||
    state.error ||
    !state.value ||
    state.value.status === "completed"
  ) {
    return undefined;
  }
  return state.value;
}
